// Cabeçalho comum das telas da Zernio.
//
// Cada assunto virou tela própria, com rota e item de menu. O que as mantém
// reconhecíveis como um conjunto é este cabeçalho: mesmo lugar, mesmo peso,
// mesma frase explicando o que aquela tela resolve.
const Cabecalho = ({ titulo, descricao, acao }) => (
  <div className="flex flex-wrap items-start justify-between gap-4">
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">
        Redes sociais
      </p>
      <h1 className="mt-0.5 text-2xl font-semibold tracking-tight">{titulo}</h1>
      {descricao && (
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          {descricao}
        </p>
      )}
    </div>

    {acao}
  </div>
);

export default Cabecalho;
